export default "__VITE_ASSET__c3e5cb20__"